import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import { withRouter } from 'react-router-dom'
import { graphql } from 'react-apollo'
import { withApollo } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import { GC_USER_ID, GC_AUTH_TOKEN } from '@/constants'
import 'react-table/react-table.css'
import * as moment from 'moment'

import { Button, Typography, Modal, Paper } from 'material-ui'
import List, { ListItem, ListItemText, ListItemIcon } from 'material-ui/List'
import TextField from 'material-ui/TextField'
import Select from 'material-ui/Select'
import { InputLabel } from 'material-ui/Input'
import { FormControl } from 'material-ui/Form'
import { ALABASTER } from '@/constants'
import SettingsOverscanIcon from 'material-ui-icons/SettingsOverscan'
import CheckIcon from 'material-ui-icons/Check'
import ReplayIcon from 'material-ui-icons/Replay'
import EditIcon from 'material-ui-icons/Edit'
import DeleteIcon from 'material-ui-icons/Delete'
import TimelapseIcon from 'material-ui-icons/Timelapse'
import AlarmOnIcon from 'material-ui-icons/AlarmOn'
import DateRangeIcon from 'material-ui-icons/DateRange'
import CommentIcon from 'material-ui-icons/Comment'
import SentimentSatisfiedIcon from 'material-ui-icons/SentimentSatisfied'
import IconButton from 'material-ui/IconButton'
import AlchemyReadingCalendar from '@/components/ChartTypes/AlchemyReadingCalendar'
import AlchemyBodyWeightWeeklyView from '@/components/ChartTypes/AlchemyBodyWeightWeeklyView'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'

import { READ_DATASETNAME, READ_DATASETS } from '@/graphql/queries/dataset'
import { CREATE_DATASET, UPDATE_DATASET } from '@/graphql/mutations/dataset'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  },
  toolbar: {
    backgroundColor: ALABASTER,
    color: 'white'
  },
  fabButton: {
    position: 'absolute',
    zIndex: 1,
    top: -15,
    left: 0,
    right: 0,
    margin: '0 auto'
  },
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4
  },
  innerWrapTimer: {
    position: 'relative',
    top: -230
  },
  innerWrapTimerText: {
    position: 'relative',
    height: 70
  },
  innerWrapTimerEmoji: {
    position: 'relative',
    top: -30,
    height: 1
  },
  centerBlock: {
    position: 'relative',
    alignItems: 'center',
    width: '100%'
  },
  icon: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    margin: theme.spacing.unit
  },
  iconPause: {
    margin: theme.spacing.unit,
    height: 180,
    width: 180
  },
  iconHistoryEdit: {
    height: 24,
    width: 24
  },
  iconBigButtons: {
    fontSize: 170
  },
  textInfo: {
    fontSize: 11,
    color: 'grey',
    opacity: 0.8,
    textAlign: 'left',
    backgroundColor: ALABASTER,
    padding: '10%'
  },
  calendar: {
    fontSize: 12,
    color: 'grey',
    opacity: 0.8,
    backgroundColor: 'white',
    width: window.innerWidth
  },
  panel: {
    fontSize: 12,
    color: 'grey',
    opacity: 0.8,
    width: '100%'
  },
  modalZero: {
    position: 'absolute',
    width: window.innerWidth * 0.4,
    height: window.innerWidth * 0.2,
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    boxShadow: theme.shadows[5],
    padding: window.innerWidth * 0.2,
    margin: window.innerWidth * 0.1,
    textAlign: 'center',
    top: window.innerHeight * 0.5
  },
  modalContent: {
    height: 200,
    width: '100%',
    textAlign: 'left',
    backgroundColor: ALABASTER,
    padding: window.innerWidth * 0.2
  },
  modalContentInput: {
    height: 200,
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'white',
    paddingLeft: window.innerWidth * 0.1
  },
  modalContentInputComment: {
    width: '100%',
    textAlign: 'center',
    paddingLeft: window.innerWidth * 0.1,
    backgroundColor: 'rgba(0, 0, 0, 0.016)'
  },
  modalContentInputCompleted: {
    height: 120,
    width: '100%',
    textAlign: 'left',
    backgroundColor: 'white',
    paddingLeft: window.innerWidth * 0.1
  },
  modalContentSmallInput: {
    height: 80,
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.016)'
  },
  modalContentSmall: {
    height: 120,
    width: '100%',
    textAlign: 'left',
    backgroundColor: '#f8f8f8',
    paddingLeft: window.innerWidth * 0.15
  },
  modalContentWhite: {
    height: 200,
    width: '100%',
    textAlign: 'left',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    padding: window.innerWidth * 0.2
  },
  textField: {
    width: window.innerWidth * 0.4
  },
  textFieldInput: {
    width: window.innerWidth * 0.4,
    backgroundColor: 'rgba(80, 227, 194, .1)'
  },
  textFieldSmall: {
    width: window.innerWidth * 0.23
  },
  textFieldMedium: {
    width: window.innerWidth * 0.33
  },
  editIcons: {
    color: 'rgba(0, 0, 0, .1)',
    width: 55,
    height: 55
  },
  editIconsSmall: {
    color: 'rgba(0, 0, 0, .1)',
    width: 20,
    height: 20
  },
  paperRoot: {
    margin: theme.spacing.unit * 4,
    boxShadow: '0px 0px 10px #eeeeee'
  },
  modalContentDone: {
    height: 50,
    width: '100%',
    textAlign: 'left',
    backgroundColor: ALABASTER
  },
  weightText: {
    textAlign: 'left',
    padding: 0
  }
})

@withApollo
@inject('resultUserBodyWeight')
@observer
@graphql(READ_DATASETS)
@graphql(CREATE_DATASET, { name: 'createDataSet' })
@graphql(UPDATE_DATASET, { name: 'UpdateDataSet' })
@graphql(READ_DATASETNAME, {
  name: 'readBodyWeightDefault',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultBodyWeight',
      userId: global.localStorage.getItem(GC_USER_ID)
    }
  })
})
@withRouter
@withStyles(styles)
export default class AlchemyBodyWeight extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      openZero: false,

      weightLB: '',
      timeComplete: moment().format(),
      date: moment().format('l'),
      break: 5,
      timer: 30 * 60,
      isSessionNow: true,
      isPaused: false,
      eAngle: 0,
      isUpdated: false,
      token: 'session',
      isCompleted: false,
      data: [],
      initialStart: true,
      isCommented: false,
      comment: ''
    }
    this.handleSessionEdit = this.handleSessionEdit.bind(this)
    this.handleSessionDelete = this.handleSessionDelete.bind(this)
    this.handleSessionDeleteAll = this.handleSessionDeleteAll.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  saveComment = () => {
    this.props.resultUserBodyWeight.sessionData.comment = this.state.comment
    //todo: [0] is true when edit instead add new
    //todo: reading as well to be fixed
    this.props.resultUserBodyWeight.updateDataBySession()
    this.updateDataPoints(
      JSON.stringify(this.props.resultUserBodyWeight.bodyWeightData)
    )
    this.setState({ isCommented: false })
  }

  handleChange = name => event => {
    if (name === 'timeComplete') {
      var inputTime = moment(event.target.value, 'HH:mm').format('HH:mm')
      var str =
        this.props.resultUserBodyWeight.sessionData.date + ' ' + inputTime
      if (!moment(new Date(str)).isValid()) {
        console.log('invalid date input')
        return
      }
      this.props.resultUserBodyWeight.sessionData.timeComplete = moment(
        new Date(str)
      ).format()
    } else if (name === 'date') {
      if (!moment(new Date(event.target.value)).isValid()) {
        console.log('invalid date input')
        return
      }
      this.props.resultUserBodyWeight.sessionData.date = moment(
        event.target.value,
        'YYYY-MM-DD'
      ).format('l')
      inputTime = moment(
        new Date(this.props.resultUserBodyWeight.sessionData.timeComplete)
      ).format('HH:mm')
      str = moment(event.target.value + ' ' + inputTime, 'YYYY-MM-DDTHH:mm')
      this.props.resultUserBodyWeight.sessionData.timeComplete = moment(
        new Date(str)
      ).format()
    } else {
      this.props.resultUserBodyWeight.sessionData[name] = event.target.value
    }
    //fixed: [0] is not true when edit
    this.props.resultUserBodyWeight.updateDataBySession()
    if (name !== 'comment') {
      this.updateDataPoints(
        JSON.stringify(this.props.resultUserBodyWeight.bodyWeightData)
      )
    } else {
      this.setState({
        comment: event.target.value,
        isCommented: true
      })
    }
  }

  getPivotArray(dataArray, rowIndex, colIndex, dataIndex) {
    //Code from https://techbrij.com
    var result = {},
      ret = []
    var newCols = []
    for (var i = 0; i < dataArray.length; i++) {
      if (!result[dataArray[i][rowIndex]]) {
        result[dataArray[i][rowIndex]] = {}
      }

      //To get column names
      if (newCols.indexOf(dataArray[i][colIndex]) === -1) {
        newCols.push(dataArray[i][colIndex])
      }
    }

    for (var key in result) {
      var sessions = []
      var mini0 = 0
      var miniX = 0
      var x = 0
      var m = 0
      var miniNew = 0
      for (var j = 0; j < dataArray.length; j++) {
        if (dataArray[j].date === key) {
          if (x === 0) {
            m = j
          }
          sessions.push(dataArray[j])
          result[dataArray[j][rowIndex]][dataArray[j][colIndex]] = sessions

          mini0 = parseFloat(dataArray[m].weightLB, 10)
          miniX = parseFloat(dataArray[j].weightLB, 10)

          if (miniNew !== 0) {
            if (miniX < miniNew) {
              miniNew = miniX
            }
          } else {
            if (miniX < mini0) {
              miniNew = miniX
            }
          }
          result[dataArray[j][rowIndex]][2] = miniNew === 0 ? mini0 : miniNew
          x += 1
        }
      }
    }

    newCols.sort(function(a, b) {
      return new Date(a) - new Date(b)
    })
    var item = []

    //Add content
    for (key in result) {
      item = []
      item.push(key)
      for (i = 0; i < newCols.length; i++) {
        item.push(result[key][newCols[i]] || '')
        item.push(result[key][2])
      }
      ret.push(item)
    }
    return ret
  }

  updateStats = (newTime, token, didUpdate) => {
    if (token === 'session') {
      this.setState({
        session: newTime
      })

      this.setState({
        timer: newTime * 60,
        isUpdated: didUpdate
      })
    }
  }

  updateBodyWeightDatabase = () => {
    const num =
      this.props.resultUserBodyWeight.bodyWeightData.length === 0
        ? 1
        : this.props.resultUserBodyWeight.bodyWeightData[0].id + 1
    const sessionData = {
      id: num,
      timeComplete: this.state.timeComplete,
      date: this.state.date,
      weightLB: this.state.weightLB,
      mood: 0,
      comment: ''
    }
    var allReadingData = this.props.resultUserBodyWeight.bodyWeightData
    allReadingData.splice(0, 0, sessionData)
    this.props.resultUserBodyWeight.updateBodyWeightData(allReadingData)
    this.props.resultUserBodyWeight.updateSessionData(sessionData)
    this.updateDataPoints(
      JSON.stringify(this.props.resultUserBodyWeight.bodyWeightData)
    )
    this.setState({
      isCompleted: true,
      weightLB: '',
      timeComplete: moment().format(),
      date: moment().format('l')
    })
  }

  handleReset = () => {
    this.setState({
      weightLB: '',
      timeComplete: moment().format(),
      date: moment().format('l')
    })
  }

  handleSessionEdit = id => {
    console.log('clicked edit')
    console.log(id)

    var allReadingData = this.props.resultUserBodyWeight.bodyWeightData

    var index = allReadingData
      .map(x => {
        return x.id
      })
      .indexOf(id)

    var sessionData = this.props.resultUserBodyWeight.bodyWeightData[index]
    this.props.resultUserBodyWeight.updateSessionData(sessionData)

    this.setState({
      comment: sessionData.comment,
      open: true
    })
  }

  handleSessionDelete = id => {
    console.log('clicked delete')
    console.log(id)

    var allReadingData = this.props.resultUserBodyWeight.bodyWeightData

    var index = allReadingData
      .map(x => {
        return x.id
      })
      .indexOf(id)

    allReadingData.splice(index, 1)
    this.props.resultUserBodyWeight.updateBodyWeightData(allReadingData)
    if (this.props.resultUserBodyWeight.bodyWeightData.length === 0) {
      this.updateDataPoints(JSON.stringify([]))
    } else {
      this.updateDataPoints(
        JSON.stringify(this.props.resultUserBodyWeight.bodyWeightData)
      )
    }
    this.setState({ data: this.props.resultUserBodyWeight.bodyWeightData })
  }

  handleSessionDeleteAll = () => {
    console.log('delete all')
    this.updateDataPoints(JSON.stringify([]))
    this.props.resultUserBodyWeight.updateBodyWeightData([])
    this.setState({ data: [] })
  }

  handleInput = name => event => {
    this.setState({
      [name]: event.target.value
    })

    if (name === 'weightLB') {
      this.setState({
        weightLB: event.target.value
      })
    } else if (name === 'date') {
      if (!moment(new Date(event.target.value)).isValid()) {
        console.log('invalid date input')
        return
      }
      this.setState({
        date: moment(event.target.value, 'YYYY-MM-DD').format('l')
      })
      var inputTime = moment(new Date(this.state.timeComplete)).format('HH:mm')
      var str = moment(event.target.value + ' ' + inputTime, 'YYYY-MM-DDTHH:mm')
      this.setState({
        timeComplete: moment(new Date(str)).format()
      })
    } else if (name === 'timeComplete') {
      inputTime = moment(event.target.value, 'HH:mm').format('HH:mm')
      str = this.state.date + ' ' + inputTime
      if (!moment(new Date(str)).isValid()) {
        console.log('invalid date input')
        return
      }
      this.setState({
        timeComplete: moment(new Date(str)).format()
      })
    }
  }

  handleComplete = () => {
    if (parseFloat(this.state.weightLB, 10) > 0) {
      this.updateBodyWeightDatabase()
    } else {
      console.log('input weight in LB')
      this.handleOpenZero()
      return
    }
  }

  handleAddNew = () => {
    this.setState({
      weightLB: '',
      timeComplete: moment().format(),
      date: moment().format('l'),
      isCompleted: false
    })
  }

  handleOpenZero = () => {
    this.setState({ openZero: true })
  }

  handleCloseZero = () => {
    this.setState({ openZero: false })
  }

  updateState = newTime => {
    var updateTime = newTime
    // max time in mins 60
    var max = 120
    // min time in mins 1
    var min = 10

    // did update time
    var isUpdated = true

    if (updateTime > max) {
      updateTime = max
    } else if (updateTime < min) {
      updateTime = min
    }

    //
    this.setState({
      session: updateTime,
      eAngle: 0
    })

    this.updateStats(updateTime, this.state.token, isUpdated)
    this.resetPomodoro()
  }

  createDataSet = async dataPoints => {
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      this.props.history.push(`/login`)
      return
    }
    // if default table is there, refuse to create
    if (this.props.readBodyWeightDefault.allDataSets.length > 0) {
      console.log('there is already default dataset there')
      return
    }

    await this.props.createDataSet({
      variables: {
        name: 'defaultBodyWeight',
        description: 'Default Body Weight tracking data',
        dataPoints: dataPoints,
        userId: userId
      },
      update: (store, { data: { createDataSet } }) => {
        console.log('default table created')
      }
    })
  }

  updateDataPoints = async dataPoints => {
    if (this.props.readBodyWeightDefault.allDataSets.length === 0) {
      console.log('no default data there')
      return
    }

    try {
      await this.props.UpdateDataSet({
        variables: {
          datasetId: this.props.readBodyWeightDefault.allDataSets[0].id,
          dataPoints: dataPoints
        },
        update: () => {
          console.log('Data updated')
        }
      })
    } catch (e) {
      console.log('There is an error: ' + e)
      if (this.props.readBodyWeightDefault.allDataSets.length === 1) {
        if (this.props.readBodyWeightDefault.allDataSets[0].dataPoints !== '') {
          this.props.resultUserBodyWeight.updateBodyWeightData(
            JSON.parse(
              this.props.readBodyWeightDefault.allDataSets[0].dataPoints
            )
          )
        }
      }
      this.signOut()
    }
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  signOut = () => {
    global.localStorage.removeItem(GC_USER_ID)
    global.localStorage.removeItem(GC_AUTH_TOKEN)
    this.props.history.push(`/login`)
  }

  render() {
    const { classes } = this.props

    if (this.props.readBodyWeightDefault.loading) {
      return <div>Loading body weight data ... </div>
    }

    if (
      this.props.resultUserBodyWeight.bodyWeightData.length === 0 &&
      !this.props.resultUserBodyWeight.created
    ) {
      if (this.props.readBodyWeightDefault.allDataSets.length === 1) {
        if (this.props.readBodyWeightDefault.allDataSets[0].dataPoints !== '') {
          //('defualt table is there.')
          this.props.resultUserBodyWeight.updateBodyWeightData(
            JSON.parse(
              this.props.readBodyWeightDefault.allDataSets[0].dataPoints
            )
          )
        }
      } else if (this.props.readBodyWeightDefault.allDataSets.length === 0) {
        //('defualt table to be added')
        this.createDataSet(
          JSON.stringify(this.props.resultUserBodyWeight.bodyWeightData)
        )
        this.props.resultUserBodyWeight.updateCreated()
      } else {
        console.log(
          this.props.readBodyWeightDefault.allDataSets.length +
            ' defualt tables, please contact support team'
        )
        return (
          <div>
            Error, please contact our support team [readBodyWeightDefault:{' '}
            {this.props.readBodyWeightDefault.allDataSets.length}]{' '}
          </div>
        )
      }
    }

    // aggregate body weight data to daily
    var dataSessionsByDate = this.getPivotArray(
      this.props.resultUserBodyWeight.bodyWeightData,
      'date',
      '',
      ''
    )

    return (
      <div>
        <div id="weeklyview" className={classes.calendar}>
          <AlchemyBodyWeightWeeklyView
            data={dataSessionsByDate}
            width={
              window.innerWidth < 630 * 1.2 ? window.innerWidth : 630 * 1.2
            }
            height={
              window.innerWidth < 630 * 1.2
                ? window.innerWidth * 0.76
                : 480 * 1.2
            }
          />
        </div>
        {this.state.isCompleted ? (
          <Paper className={classes.paperRoot}>
            <div id="timer" className={classes.centerBlock}>
              <List>
                <ListItem className={classes.modalContentInputCompleted}>
                  <ListItemIcon>
                    <SettingsOverscanIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <ListItemText
                    className={classes.weightText}
                    primary={
                      this.props.resultUserBodyWeight.sessionData.weightLB +
                      ' LB'
                    }
                    secondary={moment(
                      new Date(
                        this.props.resultUserBodyWeight.sessionData.timeComplete
                      )
                    ).calendar()}
                  />
                  <IconButton
                    onClick={() =>
                      this.handleSessionEdit(
                        this.props.resultUserBodyWeight.sessionData.id
                      )
                    }
                    disabled={this.state.isPaused}
                    className={classes.icon}
                    size="small"
                  >
                    <EditIcon style={{ color: 'grey', fontSize: 20 }} />
                  </IconButton>
                </ListItem>
                <ListItem className={classes.modalContentInputComment}>
                  <ListItemIcon>
                    <SentimentSatisfiedIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="mood">Mood</InputLabel>
                    <Select
                      native
                      value={this.props.resultUserBodyWeight.sessionData.mood}
                      onChange={this.handleChange('mood')}
                      inputProps={{
                        name: 'mood',
                        id: 'mood'
                      }}
                    >
                      <option value="" />
                      <option value={10}>:)</option>
                      <option value={20}>:|</option>
                      <option value={30}>:(</option>
                    </Select>
                  </FormControl>
                </ListItem>
                <ListItem className={classes.modalContentInputComment}>
                  <ListItemIcon>
                    <CommentIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <TextField
                    id="commentAdd"
                    label="Comment"
                    value={this.state.comment}
                    onChange={this.handleChange('comment')}
                    margin="normal"
                  />
                  <IconButton
                    onClick={this.saveComment}
                    disabled={!this.state.isCommented}
                    className={classes.icon}
                    size="small"
                  >
                    <CheckIcon
                      style={{
                        color: this.state.isCommented ? 'blue' : 'lightgrey',
                        fontSize: 20
                      }}
                    />
                  </IconButton>
                </ListItem>
              </List>
            </div>
            <div id="buttons" className={classes.innerWrapTimerText}>
              <Button
                onClick={this.handleAddNew}
                disabled={this.state.isPaused}
                className={classes.icon}
                size="small"
              >
                {' '}
                <span style={{ color: 'grey', fontSize: 15 }}>Add New</span>
                <ChevronRightIcon
                  style={{ color: 'grey', fontSize: 20, paddingLeft: 10 }}
                />
              </Button>
            </div>
          </Paper>
        ) : (
          <Paper className={classes.paperRoot}>
            <div id="timer" className={classes.centerBlock}>
              <List>
                <ListItem className={classes.modalContentInput}>
                  <ListItemIcon>
                    <SettingsOverscanIcon className={classes.editIcons} />
                  </ListItemIcon>
                  <TextField
                    id="input"
                    label="Body Weight (LB)"
                    className={classes.textFieldInput}
                    value={this.state.weightLB}
                    onChange={this.handleInput('weightLB')}
                    margin="normal"
                  />
                </ListItem>
                <ListItem className={classes.modalContentSmallInput}>
                  <ListItemIcon>
                    <DateRangeIcon className={classes.editIconsSmall} />
                  </ListItemIcon>
                  <TextField
                    id="inputdate"
                    label="Date"
                    type="date"
                    defaultValue={moment(new Date(this.state.date)).format(
                      'YYYY-MM-DD'
                    )}
                    onChange={this.handleInput('date')}
                    className={classes.textFieldMedium}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                  <ListItemIcon>
                    <AlarmOnIcon className={classes.editIconsSmall} />
                  </ListItemIcon>
                  <TextField
                    id="inputtimeComplete"
                    label="Time"
                    type="time"
                    defaultValue={moment(
                      new Date(this.state.timeComplete)
                    ).format('HH:mm')}
                    onChange={this.handleInput('timeComplete')}
                    className={classes.textFieldSmall}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      step: 300 // 5 min
                    }}
                  />
                </ListItem>
              </List>
            </div>
            <div id="buttons" className={classes.innerWrapTimerText}>
              <Button
                onClick={this.handleComplete}
                disabled={this.state.isPaused}
                className={classes.icon}
                size="small"
              >
                <CheckIcon />
              </Button>
              <Button
                onClick={this.handleReset}
                disabled={this.state.isPaused}
                className={classes.icon}
                size="small"
              >
                <ReplayIcon />
              </Button>
            </div>
          </Paper>
        )}

        <div id="calendar" className={classes.calendar}>
          <div style={{ padding: 36 }}>
            <AlchemyReadingCalendar
              data={dataSessionsByDate}
              width={
                window.innerWidth < 630 * 1.2
                  ? window.innerWidth * 1.24
                  : 630 * 1.2
              }
              height={
                window.innerWidth < 630 * 1.2
                  ? window.innerWidth * 1.24 * 0.76
                  : 480 * 1.2
              }
            />
          </div>
        </div>

        <div id="history" className={classes.textInfo}>
          {this.props.resultUserBodyWeight.bodyWeightData.length === 0 ? (
            ''
          ) : (
            <Typography variant="caption">
              <b>Body weight record history:</b>
              <Button onClick={this.handleSessionDeleteAll}>
                Delete All
                <DeleteIcon style={{ color: 'lightgrey', fontSize: 15 }} />
              </Button>
              <ul>
                {this.props.resultUserBodyWeight.bodyWeightData.map(
                  (record, index) => (
                    <li key={index}>
                      <span
                        style={{
                          backgroundColor: 'rgba(0, 0, 0, 0.1)',
                          fontSize: 9
                        }}
                      >
                        {moment(new Date(record.timeComplete)).calendar()}:
                      </span>{' '}
                      <IconButton
                        onClick={() => this.handleSessionEdit(record.id)}
                        className={classes.iconHistoryEdit}
                      >
                        <EditIcon
                          style={{ color: 'lightgrey', fontSize: 15 }}
                        />
                      </IconButton>
                      {record.weightLB} LB.
                      <IconButton
                        onClick={() => this.handleSessionDelete(record.id)}
                        className={classes.iconHistoryEdit}
                      >
                        <DeleteIcon
                          style={{ color: 'lightgrey', fontSize: 15 }}
                        />
                      </IconButton>
                      {record.comment}
                    </li>
                  )
                )}
              </ul>
            </Typography>
          )}
        </div>

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
          style={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            overflow: 'scroll',
            height: '100%',
            backgroundColor: 'white'
          }}
        >
          <Paper
            style={{
              width: '100%',
              height: '100%',
              backgroundColor: 'white',
              textAlign: 'center'
            }}
          >
            <List>
              <ListItem divider>
                <ListItemIcon>
                  <IconButton
                    color="inherit"
                    onClick={this.handleClose}
                    aria-label="Close"
                  >
                    <ChevronLeftIcon />
                  </IconButton>
                </ListItemIcon>
                <ListItemText
                  className={classes.modalHealder}
                  primary={'Body Weight Record'}
                  secondary={moment(
                    new Date(
                      this.props.resultUserBodyWeight.sessionData.timeComplete
                    )
                  ).calendar()}
                />
              </ListItem>
              <ListItem className={classes.modalContent}>
                <ListItemIcon>
                  <TimelapseIcon className={classes.editIcons} />
                </ListItemIcon>
                <TextField
                  id="wieght"
                  label="Weight (LB)"
                  className={classes.textField}
                  value={this.props.resultUserBodyWeight.sessionData.weightLB}
                  onChange={this.handleChange('weightLB')}
                  margin="normal"
                />
              </ListItem>
              <ListItem className={classes.modalContentSmall}>
                <ListItemIcon>
                  <DateRangeIcon className={classes.editIconsSmall} />
                </ListItemIcon>
                <TextField
                  id="date"
                  label="Date"
                  type="date"
                  defaultValue={moment(
                    this.props.resultUserBodyWeight.sessionData.date,
                    'l'
                  ).format('YYYY-MM-DD')}
                  onChange={this.handleChange('date')}
                  className={classes.textFieldMedium}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <ListItemIcon>
                  <AlarmOnIcon className={classes.editIconsSmall} />
                </ListItemIcon>
                <TextField
                  id="timeComplete"
                  label="End Time"
                  type="time"
                  defaultValue={moment(
                    new Date(
                      this.props.resultUserBodyWeight.sessionData.timeComplete
                    )
                  ).format('HH:mm')}
                  onChange={this.handleChange('timeComplete')}
                  className={classes.textFieldSmall}
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{
                    step: 300 // 5 min
                  }}
                />
              </ListItem>
              <ListItem className={classes.modalContent}>
                <ListItemIcon>
                  <SentimentSatisfiedIcon className={classes.editIcons} />
                </ListItemIcon>
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="mood">Mood</InputLabel>
                  <Select
                    native
                    value={this.props.resultUserBodyWeight.sessionData.mood}
                    onChange={this.handleChange('mood')}
                    inputProps={{
                      name: 'mood',
                      id: 'mood'
                    }}
                  >
                    <option value="" />
                    <option value={10}>:)</option>
                    <option value={20}>:|</option>
                    <option value={30}>:(</option>
                  </Select>
                </FormControl>
              </ListItem>
              <ListItem className={classes.modalContentWhite}>
                <ListItemIcon>
                  <CommentIcon className={classes.editIcons} />
                </ListItemIcon>
                <TextField
                  id="comment"
                  label="Commment"
                  className={classes.textField}
                  value={this.state.comment}
                  onChange={this.handleChange('comment')}
                  margin="normal"
                />
                <IconButton
                  onClick={this.saveComment}
                  disabled={!this.state.isCommented}
                  className={classes.icon}
                  size="small"
                >
                  <CheckIcon
                    style={{
                      color: this.state.isCommented ? 'blue' : 'lightgrey',
                      fontSize: 20
                    }}
                  />
                </IconButton>
              </ListItem>

              <ListItem className={classes.modalContentDone}>
                <ListItemText />
                <Button color="inherit" onClick={this.handleClose}>
                  <Typography
                    variant="body1"
                    style={{ fontSize: 18, color: 'grey' }}
                  >
                    Done
                  </Typography>
                </Button>
              </ListItem>
            </List>
          </Paper>
        </Modal>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openZero}
          onClose={this.handleCloseZero}
        >
          <div className={classes.modalZero}>
            <Typography variant="body1" id="modal-title">
              Invid weight! Please add weight in LB.{' '}
              <span role="img" aria-label="body weight">
                {' '}
                ⚖️
              </span>{' '}
            </Typography>
            <br />
            <Button
              onClick={this.handleCloseZero}
              className={classes.icon}
              size="small"
            >
              OK
            </Button>
          </div>
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/bodyweight.js